export enum NotFoundCause {
  PAGE = 'page',
  ACCOUNT = 'account',
}
